import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';

export interface PlatformStripeConfig {
  stripe_mode: 'test' | 'live';
  stripe_test_secret_key_masked: string | null;
  stripe_live_secret_key_masked: string | null;
  stripe_test_webhook_secret_masked: string | null;
  stripe_live_webhook_secret_masked: string | null;
  has_test_secret_key: boolean;
  has_live_secret_key: boolean;
  has_test_webhook_secret: boolean;
  has_live_webhook_secret: boolean;
  updated_at: string | null;
}

export interface UpdatePlatformStripeConfigParams {
  stripe_mode?: 'test' | 'live';
  stripe_test_secret_key?: string;
  stripe_live_secret_key?: string;
  stripe_test_webhook_secret?: string;
  stripe_live_webhook_secret?: string;
}

const QUERY_KEY = ['platform-stripe-config'];

export function usePlatformStripeConfig() {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: async (): Promise<PlatformStripeConfig> => {
      const { data, error } = await supabase.rpc('get_platform_stripe_config');
      if (error) throw error;
      return data as unknown as PlatformStripeConfig;
    },
  });
}

export function useUpdatePlatformStripeConfig() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: UpdatePlatformStripeConfigParams): Promise<PlatformStripeConfig> => {
      const { data, error } = await supabase.rpc('update_platform_stripe_config', {
        p_stripe_mode: params.stripe_mode,
        p_stripe_test_secret_key: params.stripe_test_secret_key,
        p_stripe_live_secret_key: params.stripe_live_secret_key,
        p_stripe_test_webhook_secret: params.stripe_test_webhook_secret,
        p_stripe_live_webhook_secret: params.stripe_live_webhook_secret,
      });
      if (error) throw error;
      return data as unknown as PlatformStripeConfig;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEY });
    },
  });
}
